import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@classify/react-core-components/styles';

import { MainHeader } from 'Modules/main-header';
import Footer from 'Modules/footer/components/Footer';

import {
  PredictiveCRMNewFeaturePromotion,
  PredictiveCRMPopUp,
} from 'Modules/predictive-crm/components';

import DisclaimersTeleporter from '../../teleporters/DisclaimersTeleporter';

import ClassicFooterContainer from '../components/ClassicFooterContainer';

interface Props {
  children?: ReactNode;
  headerSearch?: ReactNode;
  shouldHideFooter?: boolean;
}

const Breadcrumbs = styled('div')({
  position: 'relative',
});

function ClassicScreen({ headerSearch, children, shouldHideFooter = false }: Props) {
  return (
    <>
      <MainHeader headerSearch={headerSearch} />

      <DisclaimersTeleporter.Target />

      <Breadcrumbs id="breadcrumbs" />

      <main id="mainContent">{children || <Outlet />}</main>

      {!shouldHideFooter && (
        <ClassicFooterContainer>
          <Footer />
        </ClassicFooterContainer>
      )}
      <PredictiveCRMNewFeaturePromotion />
      <PredictiveCRMPopUp />
    </>
  );
}

export default ClassicScreen;
